import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Client } from "resourceModels";
import { patchFeature as patchFeatureAction, updateOne } from "actions/resources";
import { getResource } from "selectors/resources";
import { camelCaseToSnakeCase, escapeRegexp } from "services/strings";

import Checkbox from "components/Common/Checkbox";
import InputSearch from "components/Common/InputSearch";

import "./style.scss";

const BLOCK_NAME = "DevToolbarClientFeatures";

class DevFeatureCheckbox extends React.PureComponent {
  /**
  * @returns {void}
  */
  handleFeatureToggle = () => {
    const {
      client, featureName, patchFeature, updateClient
    } = this.props;
    const snakeFeatureName = camelCaseToSnakeCase(featureName);
    patchFeature({ features: { [snakeFeatureName]: !client.features.get(featureName) } });

    updateClient(client.id, {
      features: client.features.set(featureName, !client.features.get(featureName))
    });
  }

  /**
   * @returns {ReactElement|null}
   */
  render() {
    const { client, featureName } = this.props;

    return (
      <div className={`${BLOCK_NAME}__feature`} key={featureName}>
        <Checkbox
          key={featureName}
          labelSide="right"
          size="small"
          label={featureName}
          handleToggle={this.handleFeatureToggle}
          checked={client.features.get(featureName)}
          theme="dark"
        />
      </div>
    );
  }
}

DevFeatureCheckbox.propTypes = {
  featureName: PropTypes.string.isRequired,
  client: PropTypes.instanceOf(Client).isRequired,
  patchFeature: PropTypes.func.isRequired,
  updateClient: PropTypes.func.isRequired
};

export class DevToolbarClientFeatures extends React.PureComponent {
  state = {
    featureSearchValue: ""
  };

  /**
   * Methods
   */


  /**
   * @returns {ReactElement|null}
   */
  render() {
    const { client, patchFeature, updateClient } = this.props;
    const { featureSearchValue } = this.state;
    const searchRegExp = new RegExp(escapeRegexp(featureSearchValue), "i");

    if (!client) {
      return null;
    }

    return (
      <section className={BLOCK_NAME}>
        <h1 className={`${BLOCK_NAME}__title`}>Client features</h1>

        <div className={`${BLOCK_NAME}__search-input`}>
          <InputSearch
            value={featureSearchValue}
            onChange={e => this.setState({ featureSearchValue: e.target.value })}
          />
        </div>

        {client.features.keySeq()
          .filter(featureName => searchRegExp.test(featureName))
          .map(featureName => (
            <DevFeatureCheckbox
              key={featureName}
              client={client}
              featureName={featureName}
              patchFeature={patchFeature}
              updateClient={updateClient}
            />
          ))}
      </section>
    );
  }
}

DevToolbarClientFeatures.propTypes = {
  client: PropTypes.instanceOf(Client).isRequired,
  patchFeature: PropTypes.func.isRequired,
  updateClient: PropTypes.func.isRequired
};

DevToolbarClientFeatures.defaultProps = {};

/**
 * @param {Object} state
 * @returns {Object}
 */
function mapStateToProps(state) {
  return {
    client: getResource(state, "client")
  };
}

/**
 * @param {Function} dispatch
 * @returns {Object.<Function>}
 */
function mapDispatchToProps(dispatch) {
  return {
    updateClient: (id, data) => dispatch(updateOne("client", id, data)),
    patchFeature: featureData => dispatch(patchFeatureAction(featureData))
  };
}

const Connector = connect(mapStateToProps, mapDispatchToProps)(DevToolbarClientFeatures);

Connector.propTypes = {};
Connector.defaultProps = {};

export default Connector;
